import axiosInstance from '../../../redux/axiosInstance/';

class TaxServiceService {

  listServices(page = 1, perPage = 100, search = '') {
    const params = { page, perPage };
    if (search) params.search = search;
    return axiosInstance.get('/tax-services/tax-services/list', { params });
  }

  listServicesByCategory(categoryId, page = 1, perPage = 100) {
    return axiosInstance.get(`/tax-services/tax-services/list/category/${categoryId}`, {
      params: { page, perPage },
    });
  }

  getServiceBySlug(slug) {
    return axiosInstance.get(`/tax-services/tax-services/view/${slug}`);
  }

  createService(data) {
    return axiosInstance.post('/tax-services/tax-services/admins/create', data);
  }

  updateService(slug, data) {
    return axiosInstance.patch(`/tax-services/tax-services/admins/update/${slug}`, data);
  }

  deleteService(slug) {
    return axiosInstance.delete(`/tax-services/tax-services/admins/delete/${slug}`);
  }
}

export default new TaxServiceService();
